import { Menu } from '@material-ui/core';
import React from 'react';

const menuListProps = {
  disablePadding: true,
  style: { marginBottom: '0px' }
};

class Tm3Menu extends React.Component {
  get MenuListProps() {
    const { MenuListProps = {} } = this.props;
    return { ...MenuListProps, ...menuListProps };
  }

  render() {
    const { children, ...props } = this.props;
    return (
      <Menu {...props} MenuListProps={this.MenuListProps}>
        {children}
      </Menu>
    );
  }
}

export default Tm3Menu;

export { Tm3Menu };
